module.exports = __webpack_public_path__ + "static/media/orange-half-atw.cad8f3aa.png";